/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteProjectStagesCommand } from '../../models/delete-project-stages-command';
import { DeleteProjectStagesCommandResult } from '../../models/delete-project-stages-command-result';

export interface ApiProjectStagesDeleteProjectStagesDelete$Params {
      body?: DeleteProjectStagesCommand
}

export function apiProjectStagesDeleteProjectStagesDelete(http: HttpClient, rootUrl: string, params?: ApiProjectStagesDeleteProjectStagesDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectStagesCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectStagesDeleteProjectStagesDelete.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteProjectStagesCommandResult>;
    })
  );
}

apiProjectStagesDeleteProjectStagesDelete.PATH = '/api/ProjectStages/DeleteProjectStages';
